import { render, staticRenderFns } from "./VProductSelect.vue?vue&type=template&id=0eddb95d&"
import script from "./VProductSelect.vue?vue&type=script&lang=js&"
export * from "./VProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./VProductSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default,VBadge: require('/app/components/ui/v-badge/VBadge.vue').default})
